export default __webpack_public_path__ + "static/logo-8836e57eec246aa0c41a088040aec6db.png";